import type { EditProfileInfoDrawerProps } from './ProfileInfoDrawer';
import { useEffect, useState, type FC, type PropsWithChildren } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Flex, Text } from '@eqi-investimentos/react';
import { useAuth } from '@/contexts/AuthContext';
import { OtpCodeInput } from '@/components/organisms/OtpCodeInput';
export const OTPConfirmation: FC<OTPConfirmationProps> = ({
  children,
  isNewValueSet,
  isOTPExpired,
  type,
  isError = false,
  isLoading = false,
  handleOTPExpiration,
  handleOTPValidation,
  resendOTP
}) => {
  const {
    t
  } = useTranslation('common');
  const {
    identifierAuth,
    userRemembered,
    verifyOtpCode
  } = useAuth();
  const [hasOTPError, setHasOTPError] = useState(isError);
  const [isValidatingOTP, setIsValidatingOTP] = useState(false);
  const [isOTPValid, setIsOTPValid] = useState(false);
  const validateOTP = async (token: string) => {
    setHasOTPError(false);
    if (token.length < 6) return;
    setIsValidatingOTP(true);
    const identifier = identifierAuth && 'identifier' in identifierAuth ? identifierAuth?.identifier : userRemembered?.email;
    const verified = await verifyOtpCode({
      identifier: identifier ?? '',
      token
    });
    setIsValidatingOTP(false);
    if (verified) {
      setIsOTPValid(true);
    } else {
      setHasOTPError(true);
    }
  };
  useEffect(() => {
    setHasOTPError(isError);
  }, [isError]);
  if (type === 'name' || !isNewValueSet || isOTPValid) {
    return children;
  }
  if (isOTPExpired) {
    return <Flex flexDir="column" gap="1.875rem">
        <Text>{t('drawers.personalInfo.otpConfirmation.expiredHeader')}</Text>
        <Text>
          {t('drawers.personalInfo.otpConfirmation.expiredDescription').replace('<type>', type)}
        </Text>
        {children}
      </Flex>;
  }
  return <Flex flexDir="column" gap="m" data-sentry-element="Flex" data-sentry-component="OTPConfirmation" data-sentry-source-file="OTPConfirmation.tsx">
      <Text size="h6" color="content.primary" data-sentry-element="Text" data-sentry-source-file="OTPConfirmation.tsx">
        {t('drawers.personalInfo.otpConfirmation.header')}
      </Text>
      <Text size="xl" color="content.primary" data-sentry-element="Text" data-sentry-source-file="OTPConfirmation.tsx">
        {t('drawers.personalInfo.otpConfirmation.description').replace('<type>', type)}
      </Text>
      <OtpCodeInput isDisabled={isLoading} error={hasOTPError ? t('screens.otp.errorCodeValidation') : ''} loading={isValidatingOTP} otpValidationTime={300} handleCode={handleOTPValidation || validateOTP} handleExpiration={handleOTPExpiration} resendSendOtp={resendOTP} inputStyle={{
      height: '3.125rem',
      width: '3.125rem'
    }} data-sentry-element="OtpCodeInput" data-sentry-source-file="OTPConfirmation.tsx" />
    </Flex>;
};
type OTPConfirmationProps = PropsWithChildren<{
  isNewValueSet: boolean;
  isOTPExpired: boolean;
  type: EditProfileInfoDrawerProps['type'];
  isLoading?: boolean;
  isError?: boolean;
  resendOTP: () => void;
  handleOTPExpiration: () => void;
  handleOTPValidation?: (token: string) => void | Promise<void>;
}>;